import { createDebugger } from "@iotize/common/debug";

export const debug = createDebugger(`@iotize/device-com-wifi.cordova`);
